export default __webpack_public_path__ + "static/media/pawn_black.be5d44ca.svg";